import React from 'react';
import { Box, Typography } from '@mui/material';
import { EDIT_OBJECT_TOKENS } from './editObjectTokens';

export interface SectionHeadProps {
  title: string;
  /** Right-aligned counter or status text (e.g. "3 of 20 images"). */
  count?: string;
}

/**
 * Mirrors the design's `.sec-head` block: serif red H3 on the left, light
 * gray count text on the right, separated from the body by a 1px line-soft
 * bottom border.
 */
export const SectionHead: React.FC<SectionHeadProps> = ({ title, count }) => (
  <Box
    data-testid="edit-object-section-head"
    sx={{
      display: 'flex',
      alignItems: 'baseline',
      gap: 1.25,
      mt: 3,
      mb: 1,
      pb: 1,
      borderBottom: `1px solid ${EDIT_OBJECT_TOKENS.color.lineSoft}`,
    }}
  >
    <Typography
      component="h3"
      sx={{
        fontFamily: EDIT_OBJECT_TOKENS.font.serif,
        fontSize: '1rem',
        fontWeight: 700,
        color: EDIT_OBJECT_TOKENS.color.aliRed700,
        flex: 1,
        m: 0,
        lineHeight: 1.3,
      }}
    >
      {title}
    </Typography>
    {count && (
      <Typography
        data-testid="edit-object-section-head-count"
        sx={{
          fontSize: 12,
          color: EDIT_OBJECT_TOKENS.color.slate500,
        }}
      >
        {count}
      </Typography>
    )}
  </Box>
);

export default SectionHead;
